export function fixRequiredBubbleBehideNavbar() {
	const elements = document.querySelectorAll('input,select,textarea')
	const invalidListener = function() {
		this.scrollIntoView(false)
	}
	for (let i = elements.length; i--; ) elements[i].addEventListener('invalid', invalidListener)
}
